import {getFileStream, request} from './base'

export default {
    queryListByUserId(data) {
        return request('/recharge/queryListByUserId', data, 'get')
    },
    queryPage(data) {
        return request('/recharge/queryPage', data, 'get')
    },
    export(data) {
        return getFileStream('/recharge/export', data, 'get')
    },
}
